import owColors from '@/plugins/ow-colors';
import i18n from '@/plugins/vue-i18n';
import { shellBridge } from '@/webshell-embed/platform-bridge';

// AG Grid cell renderer for the product key. Embedded, it is a link that opens the app-provided
// product-summary component in a modal - mechanism 4 of ADR-011 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/011-shared-ux-and-cross-microfrontend-components.md
// Standalone there is no bridge, so it renders as plain text.
export function renderProductSummaryCell(params) {
  const { value } = params;
  if (value === null || value === undefined || value === '') return '';

  // Plain text unless some app actually provides the component in the contract major we bind props
  // for. Whoever owns it may be disabled, absent from this tenant or outside the user's access — a
  // link we can't honour reads as broken.
  const bridge = shellBridge();
  if (!bridge?.components.has('products', 'product-summary', '1')) return String(value);

  const productKey = String(params.data?.productKey ?? value);
  const description = params.data?.itemDescription ?? '';

  const link = document.createElement('a');
  link.textContent = value;
  link.href = '#';
  link.style.color = owColors.assortmentSecondaryBlue;
  link.style.cursor = 'pointer';
  link.style.textDecoration = 'underline';
  link.addEventListener('click', event => {
    event.preventDefault();
    bridge.components.openModal({
      namespace: 'products',
      name: 'product-summary',
      contractVersion: '1',
      props: { productKey, description },
      title: i18n.t('general.productSummaryTitle', { productKey }),
    });
  });
  return link;
}
